import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ScopeSequenceStandard } from 'src/app/services/graphql/scope-sequence-standards-response';
import { StandardSetType } from '../../settings/standard-set-settings.constants';

@Component({
  selector: 'app-standard-result',
  templateUrl: './standard-result.component.html',
  styleUrls: ['./standard-result.component.scss']
})
export class StandardResultComponent implements OnInit {
  @Input() public selectedSkillOption!: string;
  @Input() public index: number = -1;
  @Input() public scopeSequenceStandard: ScopeSequenceStandard | null = null;
  @Input() public skillOrder: string = '';

  public isActiveStandardCard: boolean = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.isActiveStandardCard = this.isActiveStandardResult();
  }

  public navigateToStandard(standardId: string | undefined): void {
    if (standardId) {
      if (this.isActiveStandardCard) {
        this.router.navigate([`/plan-instruction/${this.getStandardSetType()}/${standardId}`]);
      }
    }
  }

  public getNoSkillsAlignedText(): string {
    if (this.selectedSkillOption === StandardSetType.Envision) {
      return 'No skills aligned to this topic';
    }
    return 'No skills aligned to this standard';
  }

  private isActiveStandardResult(): boolean {
    if (this.scopeSequenceStandard?.skillNames.length !== 0) {
      return true;
    }
    return false;
  }

  private getStandardSetType(): StandardSetType {
    return this.skillOrder.toLowerCase().includes(StandardSetType.Envision.toLowerCase())
      ? StandardSetType.Envision
      : StandardSetType.Renaissance;
  }
}
